import { FormattedMessage } from 'react-intl';
import BaseModal from 'src/components/BaseModal';
import { BaseModalProps } from 'src/components/BaseModal/BaseModal';
import { TSubscriptionGroup } from 'src/types/TSubscription';
import { formatToLocal } from 'src/utils/common';

import styles from '../styles.module.scss';
import messages from '../messages';

interface GroupsModalProps extends BaseModalProps {
  groups: TSubscriptionGroup[];
}

/**
 * Every group drawing on this subscription — opened from the "Click to view"
 * button in the multi-group strip (same reveal pattern as the KEYS column).
 * This page lists ONE group's members while contributor seats are pooled
 * across all of them; this modal is where the rest of the pool is visible.
 *
 * Read-only by design: there is no customer-facing group management, so the
 * modal reports rather than offering actions.
 */
const GroupsModal = ({ groups, ...rest }: GroupsModalProps) => (
  <BaseModal {...rest}>
    <h3>
      <FormattedMessage {...messages.groupsModalTitle} />
    </h3>
    <p className={styles.groupsModalIntro}>
      <FormattedMessage
        {...messages.groupsStripIntro}
        values={{ count: groups.length }}
      />
    </p>
    <ul className={styles.groupList}>
      {groups.map((group) => (
        <li key={group.group_id} className={styles.groupCard}>
          <div className={styles.groupCardHead}>
            <span className={styles.groupCardName}>{group.name}</span>
            <span className={styles.groupMembersPill}>
              <FormattedMessage
                {...messages.groupMembers}
                values={{ count: group.member_count }}
              />
            </span>
          </div>
          <p className={styles.groupCardMeta}>
            <FormattedMessage
              {...messages.groupMeta}
              values={{
                id: group.group_id,
                created: formatToLocal(group.created_at),
              }}
            />
          </p>
        </li>
      ))}
    </ul>
  </BaseModal>
);

export default GroupsModal;
